import React from "react";
import useSWR from 'swr';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Keyboard, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// API configuration constants
const API_URL = `${process.env.REACT_APP_API_FOLDER}get_galleries2/`;
const API_TOKEN = process.env.REACT_APP_API_TOKEN;

// SWR fetcher with authorization
const fetcher = (url) =>
  fetch(url, { headers: { "X-API-TOKEN": API_TOKEN } })
    .then((res) => {
      if (!res.ok) throw new Error(`Network response was not ok: ${res.status}`);
      return res.json();
    });

const GalleryWrapper2 = () => {
  // Use SWR to fetch an array of filenames
  const { data: filenames, error } = useSWR(API_URL, fetcher);
  console.log(filenames);

  if (error) {
    return <div>Error loading gallery: {error.message}</div>;
  }
  if (!filenames) {
    return <div>Loading gallery...</div>;
  }

  return (
    <div style={{ width: '100vw', height: '100vh', position: 'relative' }}>
      {/* Floating badge */}
      <a
        href="https://instagram.com/camp_fr"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'absolute',
          top: '110px',  // moved down to float over gallery images
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          color: '#fff',
          padding: '8px 12px',
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
          zIndex: 1000,
        }}
      >
        More images:&nbsp;<i className="fa-brands fa-square-instagram"></i>&nbsp;camp_fr
      </a>

      <Swiper
        modules={[Navigation, Pagination, Keyboard, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        keyboard={{ enabled: true }}
        loop={true}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        style={{ width: '100%', height: '100%' }}
      >
        {filenames.map((filename) => (
          <SwiperSlide key={filename}>
            <img
              src={`https://www.campfr.com/images/gallery/all/${filename}`}
              alt={filename}
              style={{
                objectFit: 'cover',
                width: '100%',
                height: '100%',
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default GalleryWrapper2;
